<ng-container *transloco="let t">
  @if (financiers$ | async; as financiers) {
    @if (
      !(
        isSharedView &&
        readOnlyState() !== ReadonlyState.Editable &&
        financiers.length === 0
      )
    ) {
      <lib-input-container
        [label]="isSharedView ? undefined : t('worksite_financiers_other')"
        [questionMarkText]="
          isSharedView ? undefined : t('worksite_financier_questionmark')
        "
        [requiredTextEnd]="false"
        [required]="true"
        [hideBelow]="true"
        [hideAbove]="isSharedView"
      >
        <div class="financier-container">
          <div>
            <div class="row" [class.mt-2]="!isSharedView">
              <div class="col-12 col-lg-10">
                <lib-list
                  [addMoreVisible]="
                    allowedToAddMore && !readOnlyState() && !worksiteInactive()
                  "
                  [addMoreText]="t('worksite_btn_add_financier')"
                  (addMore)="onOpenOregModal(oregModal)"
                >
                  @if (financiers.length > 0) {
                    <div>
                      @for (fin of financiers; track $index) {
                        <div>
                          <lib-list-item
                            (remove)="
                              onOpenRemoveWorksiteModal(removeModal, fin)
                            "
                            [removeVisible]="true"
                            [readOnlyState]="readOnlyState()"
                            [title]="fin.company?.name"
                            [isMobile]="isMobile()"
                          >
                            <div view-title>
                              <div class="heading-size-5 d-flex">
                                <lib-dot-indicator
                                  [ariaLabel]="t('worksite_has_changes')"
                                  [isVisible]="
                                    newFinanciers.has(fin.id) && showChanges()
                                  "
                                />
                                @if (worksiteInactive()) {
                                  <div class="title-single-line">
                                    <s class="inactive-text">
                                      {{ fin.company?.name }}
                                    </s>
                                  </div>
                                } @else {
                                  {{ fin.company?.name }}
                                }
                              </div>
                              <div class="view" view>
                                @if (isForeign(fin.id)) {
                                  @if (fin.company?.vat) {
                                    <p
                                      class="m-0"
                                      [ngClass]="
                                        worksiteInactive()
                                          ? 'inactive-text'
                                          : ''
                                      "
                                    >
                                      {{ fin.company?.vat }}
                                    </p>
                                    <p
                                      [ngClass]="
                                        worksiteInactive()
                                          ? 'inactive-text'
                                          : ''
                                      "
                                    >
                                      {{ fin.name }}
                                    </p>
                                  }
                                } @else if (
                                  fin.company?.nationalRegistrationNumber
                                ) {
                                  <p
                                    class="m-0"
                                    [ngClass]="
                                      worksiteInactive() ? 'inactive-text' : ''
                                    "
                                  >
                                    {{
                                      fin.company?.nationalRegistrationNumber
                                    }}
                                  </p>
                                  <p
                                    [ngClass]="
                                      worksiteInactive() ? 'inactive-text' : ''
                                    "
                                  >
                                    {{ fin.name }}
                                  </p>
                                }
                              </div>
                            </div>
                          </lib-list-item>
                        </div>
                      }
                    </div>
                  }
                </lib-list>
              </div>
            </div>
          </div>
        </div>
      </lib-input-container>
    }
  }

  <ng-template #oregModal>
    <lib-modal [showCloseButton]="true" (closeModal)="onCloseOregModal()">
      <lib-oreg
        [isFinancierSearch]="true"
        (selectedWorksiteEvent)="onSelectedWorksite($event)"
        [alreadySelectedWorksites]="combinedProviderIds"
        [alreadySelectedFinanciers]="financiersProviderIds"
      ></lib-oreg>
    </lib-modal>
  </ng-template>

  <ng-template #removeModal>
    <lib-modal
      (closeModal)="onCloseRemoveModal()"
      [showCloseButton]="true"
      [title]="t('worksite_remove_financier_modal_title')"
      [primaryButtonText]="t('worksite_btn_remove')"
      [showPrimaryButton]="true"
      [secondaryButtonText]="t('worksite_btn_keep')"
      [showSecondaryButton]="true"
      (primaryButton)="onRemoveFinancier()"
      (secondaryButton)="onCloseRemoveModal()"
    >
    </lib-modal>
  </ng-template>
</ng-container>
